<template>
  <FormTemplate>
    <template v-slot:form-body>
      <v-form ref="formImagesWorks" @submit.prevent="saveForm">
        <v-row>
          <v-col cols="12" md="3">
            <label for="file-input-reel">Imagen</label>
          </v-col>
          <v-col cols="12" md="9" class="pb-0">
            <v-file-input
              id="file-input-reel"
              v-model="image"
              outlined
              dense
              placeholder="Selecciona una imagen"
              :autocomplete="autocomplete"
              :rules="payloadEdited ? [] : required"
              chips
            ></v-file-input>
          </v-col>

          <v-col offset-md="3" cols="9">
            <v-btn type="submit" :disabled="loading" :loading="loading" color="primary"> Guardar </v-btn>
            <v-btn type="reset" @click="reset" class="mx-2" outlined> Limpiar </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </template>
  </FormTemplate>
</template>

<script>
import FormTemplate from '@/components/forms/FormTemplate.vue'
import DatatableWorks from '@/views/pages/works/DatatableWorks.vue'
export default {
  components: {
    FormTemplate,
    DatatableWorks,
  },
  props: {
    payloadEdited: Object,
    loading: Boolean,
    idWorks: Number,
  },
  data() {
    return {
      required: [v => !!v || 'Requerido'],
      autocomplete: 'off',
      isEdited: this.payloadEdited ? true : false,
      image: null,
      payload: this.payloadEdited ? { ...this.payloadEdited } : {},
      imagesWorks: this.imagesWorksEdited ? { ...this.imagesWorksEdited } : {},
    }
  },
  methods: {
    validateForm() {
      return this.$refs.formImagesWorks.validate()
    },
    reset() {
      this.image = null
      this.$refs.formImagesWorks.resetValidation()
    },
    saveForm() {
      if (!this.validateForm()) return
      const formData = new FormData()
      formData.append('id_work', this.idWorks)
      if (this.image) {
        formData.append('file_works', this.image)
      }
      const DTO = {
        id: this.payload.id,
        formData,
      }
      // // console.log(DTO)
      if (this.isEdited) {
        this.$emit('beforeUpdate', DTO)
      } else {
        this.$emit('beforeCreate', DTO)
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
